import Vue from 'vue'
import Vuex from 'vuex'
import config from '../const/config'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)
export default new Vuex.Store({
  strict: process.env.NODE_ENV !== "production",
  state: {
    //システムバージョン ここで変更
    system_version: "V.1.5.9",
    //--------------
    // ログインユーザ情報
    //--------------
    //ログイン契約コード
    contract_code: "",
    contractor_name: "",
    //ログインユーザーID
    user_id: "",
    //管理企業コード
    corp_code: "",
    corp_name: "",
    //
    user_type: "",
    user_level: "",
    user_name: "",
    //
    prefecture_code: 1,
    //--------------
    // 
    //--------------
    //ログイン状態管理
    is_login: false,
    //ローディング表示
    isLoading: false,
    authErrorModalShow: false,
    serverErrorModalShow: false,
    //ライセンスの有効期限
    is_near_license_limit: false,
    //--------------
    // 処理対象キー保持
    // 別画面から遷移する時に必要な受け渡し情報
    //--------------
    is_process_pass: false,
    //処理対象年
    process_target_year: null,
    //処理対象月
    process_target_month: null,
    //処理対象社員番号
    process_target_staff_code: null,
    //---------------
    disp_preset_guide: false,
    //---------------
    target_help_keyword: "",
    //---------------
    // 登録状況
    //---------------
    //登録データの編集中
    editing_regist_data: false,
    //---------------
    // 
    //---------------
    //選択されたライセンス更新対象の企業リスト
    license_update_corp_list: [],
    //新規追加企業の注文数
    add_corp_order_count: 0,

  },
  getters: {
    getSystemVersion: state => {
      return state.system_version;
    },
    getAuthErrorModalShow: state => {
      return state.authErrorModalShow;
    },
    getServerErrorModalShow: state => {
      return state.serverErrorModalShow;
    },
    /**ログイン契約コード取得 */
    getContractCode: state => {
      return state.contract_code;
    },
    getContractorName: state => {
      return state.contractor_name;
    },
    /**ログインユーザID */
    getUserId: state => {
      return state.user_id;
    },
    isUserCharger: state => {
      return state.user_level == config.VALUE.SYSTEM_USER_LEVEL_CHARGER;
    },
    /**管理企業コード取得 */
    getCorpCode: state => {
      return state.corp_code;
    },
    getCorpName: state => {
      return state.corp_name;
    },
    /**ログイン状態取得 */
    getIsLogin: state => {
      return state.is_login;
    },
    /**ライセンスの有効期限が近い */
    getIsNearLicenseLimit: state => {
      return state.is_near_license_limit;
    },
    getDispPresetGuide: state => {
      if (state.disp_preset_guide == config.VALUE.DISP_PRESET_GUIDE_DISP) {
        return true;
      } else {
        return false;
      }
    },
    //ヘルプキーワードの取得
    getTargetHelpKeyword: state => {
      return state.target_help_keyword;
    },
    //--------------
    // 処理対象キー保持
    //--------------
    /**処理対象年月モード */
    getIsProcessPass: state => {
      return state.is_process_pass;
    },
    /**処理対象年取得 */
    getProcessTargetYear: state => {
      return state.process_target_year;
    },
    /**処理対象月取得 */
    getProcessTargetMonth: state => {
      return state.process_target_month;
    },
    /**処理対象社員CD取得 */
    getProcessTargetStaffCode: state => {
      return state.process_target_staff_code;
    },
    //---------------
    // 登録状況
    //---------------
    //登録データの編集中判定
    editingRegistData: state => {
      return state.editing_regist_data;
    },

    //---------------
    // ライセンス更新
    //---------------
    getLicenseUpdateCorpList: state => {
      return state.license_update_corp_list;
    },
    getAddCorpOrderCount: state => {
      return state.add_corp_order_count;
    },
    isLicenseUpdateMode: state => {
      return state.license_update_corp_list.length >= 1;
    },
    isAddCorpOrderMode: state => {
      return state.add_corp_order_count >= 1;
    }
  },
  mutations: {
    setIsLoading: (state, isLoading) => {
      state.isLoading = isLoading;
    },
    setAuthErrorModalShow: (state, authErrorModalShow) => {
      state.authErrorModalShow = authErrorModalShow;
    },
    setServerErrorModalShow: (state, serverErrorModalShow) => {
      state.serverErrorModalShow = serverErrorModalShow;
    },
    /**ログインユーザ情報セット*/
    setLoginUserInfo: function (state, param) {
      state.user_id = param.user_id;
      state.user_name = param.user_name;
      state.system_authority_type = param.system_authority_type;
      state.flg_allocation_calc = param.flg_allocation_calc;
    },
    /**契約コードセット*/
    setContractCode: function (state, contract_code) {
      state.contract_code = contract_code;
    },
    /**契約者名をセット*/
    setContractorName: function (state, value) {
      state.contractor_name = value;
    },
    /**管理企業名をセット*/
    setCorpName: function (state, value) {
      state.corp_name = value;
    },
    /**管理企業情報セット*/
    setCorpInfo: function (state, param) {
      state.corp_code = param.corp_code;
      state.corp_name = param.corp_name;
    },
    /** */
    setIsNearLicenseLimit: function (state, value) {
      state.is_near_license_limit = value;
    },
    setDispPresetGuide: function (state, value) {
      state.disp_preset_guide = value;
    },
    //ヘルプキーワードの設定
    setTargetHelpKeyword: function (state, value) {
      state.target_help_keyword = value;
    },
    clearTargetHelpKeyword: function (state) {
      state.target_help_keyword = "";
    },
    //--------------
    // 処理対象キー保持
    //--------------
    /**処理対象年セット*/
    setProcessTargetYear: function (state, process_target_year) {
      state.process_target_year = process_target_year;
      state.is_process_pass = true;
    },
    /**処理対象月セット*/
    setProcessTargetMonth: function (state, process_target_month) {
      state.process_target_month = process_target_month;
      state.is_process_pass = true;
    },
    /**処理対象年月セット*/
    setProcessTargetYearMonth: function (state, params) {
      state.process_target_year = params.process_target_year;
      state.process_target_month = params.process_target_month;
      state.is_process_pass = true;
    },
    /**処理対象社員CDセット*/
    setProcessTargetStaffCode: function (state, value) {
      state.process_target_staff_code = value;
      state.is_process_pass = true;
    },
    /**処理対象社員CDをクリア*/
    clearProcessTargetStaffCode: function (state) {
      state.process_target_staff_code = null;
      state.is_process_pass = false;
    },
    /**処理対象の年月をクリア*/
    clearProcessTargetYearMonth: function (state) {
      state.process_target_year = null;
      state.process_target_month = null;
      state.is_process_pass = false;
    },
    //---------------
    // 登録状況
    //---------------
    //登録データの編集中判定
    setEditingRegistData: function (state, value) {
      state.editing_regist_data = value;
    },
    //---------------
    // ライセンス更新
    //---------------
    setLicenseUpdateCorpList: function (state, value) {
      state.license_update_corp_list = value;
    },
    setAddCorpOrderCount: function (state, value) {
      state.add_corp_order_count = value;
    },
    initLicenseOrder: function (state) {
      state.license_update_corp_list = [];
      state.add_corp_order_count = 0;
    },
    //--------------
    // ログイン状態
    //--------------
    login: function (state) {
      state.is_login = true;
    },
    logout: function (state) {
      state.is_login = false;
    },
    setTargetDateInfo: function (state, param) {
      state.target_date = param.target_date;
      state.is_from_work_calendar = param.is_from_work_calendar;
    },
    setIsFromWorkCalendar: function(state, param) {
      state.is_from_work_calendar = param.is_from_work_calendar;
    },
    setWorkSummaryToWorkState: function(state, param){
      state.is_from_work_summary = param.is_from_work_summary
      state.target_user_cd = param.target_user_cd;
      state.target_user_name = param.target_user_name;
      state.target_year = param.target_year;
      state.target_month = param.target_month
    },
    setIsFromWorkSummary: function(state, param) {
      state.is_from_work_summary = param.is_from_work_summary;
    },
  },
  actions: {
    startLoading({ commit }) {
      commit("setIsLoading", true);
    },
    stopLoading({ commit }) {
      commit("setIsLoading", false);
    },
    authErrorModalShow({ commit }) {
      commit("setAuthErrorModalShow", true);
    },
    authErrorModalHide({ commit }) {
      commit("setAuthErrorModalShow", false);
    },
    serverErrorModalShow({ commit }) {
      commit("setServerErrorModalShow", true);
    },
    serverErrorModalHide({ commit }) {
      commit("setServerErrorModalShow", false);
    },
  },
  plugins: [createPersistedState({ key: 'vuex_work_manage', storage: window.sessionStorage })],
})